module.exports = __webpack_public_path__ + "img/provident_fund.a828a001.png";